import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import ConfirmationDialog from 'components/Utils/ConfirmationDialog';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const UnsubscribeButton = (props) => {
  const dispatch = useAppDispatch();

  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  async function unsubscribe() {
    setLoading(true);
    let result = await dispatch(api.Payments.unsubscribe({ userId: props.patient.id }), {
      title: 'Unsubscription',
      successText: 'Unsubscribed Successfully!',
    });
    setLoading(false);
    if (result) setConfirmationDialog(false);
  }

  function closeConfirmationDialog() {
    setConfirmationDialog(false);
  }

  function openConfirmationDialog() {
    setConfirmationDialog(true);
  }

  return (
    <>
      <DefaultButton
        name="Unsubscribe"
        className="red"
        onClick={openConfirmationDialog}
        disabled={props.disabled}
        style={props.style}
      />
      {confirmationDialog && (
        <ConfirmationDialog
          title="Unsubscribing?"
          message="You'll miss out on our full range of amazing services. Are you sure you want to do this?"
          open={confirmationDialog}
          onConfirm={unsubscribe}
          onCancel={closeConfirmationDialog}
          loadingState={loading}
        />
      )}
    </>
  );
};

UnsubscribeButton.propTypes = {
  patient: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

export default UnsubscribeButton;
